"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { useTranslations } from "next-intl";
import { Icon } from "@repo/ui/icon";
import { useAudience } from "@/components/common/audience";
import { AudienceTabs } from "@/components/navigation/audience-tabs.component";
import { useNavigationState } from "@/components/navigation/navigation-provider";
import type { RichMenuItem } from "@/components/navigation/navigation.types";
import { PLANNER_ENABLED } from "@/lib/feature-flags";
import { MobileMenuLevel2 } from "./mobile-menu-level2.component";
import { MobileMenuLevel3 } from "./mobile-menu-level3.component";
interface MobileMenuOverlayProps {
  defaultActiveSectionId?: string | null;
  /** Show at every breakpoint; mobile-only by default. */
}
export function MobileMenuOverlay(t0) {
  const $ = _c(53);
  const {
    defaultActiveSectionId: t1
  } = t0;
  const defaultActiveSectionId = t1 === undefined ? null : t1;
  const {
    navigationData,
    isMobileMenuOpen,
    closeMobileMenu,
    openSearch
  } = useNavigationState();
  const {
    activeTab
  } = useAudience();
  const t = useTranslations("navigation");
  const isBusinesses = activeTab === "businesses";
  const [activeSectionId, setActiveSectionId] = useState(defaultActiveSectionId);
  const primaryMenuItems = isBusinesses ? navigationData.businessPrimaryMenuItems : navigationData.primaryMenuItems;
  const utilityItems = navigationData.utilityMenu?.items ?? null;
  const effectiveSectionId = isMobileMenuOpen ? activeSectionId : null;
  let t2;
  if ($[0] !== effectiveSectionId || $[1] !== primaryMenuItems) {
    t2 = primaryMenuItems?.find(menu => menu.type === "richMenu" && menu.id === effectiveSectionId);
    $[0] = effectiveSectionId;
    $[1] = primaryMenuItems;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const activeMenu = t2;
  let t3;
  if ($[3] !== closeMobileMenu) {
    t3 = () => {
      setActiveSectionId(null);
      closeMobileMenu();
    };
    $[3] = closeMobileMenu;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClose = t3;
  let t4;
  if ($[5] !== handleClose || $[6] !== openSearch) {
    t4 = () => {
      handleClose();
      openSearch();
    };
    $[5] = handleClose;
    $[6] = openSearch;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleSearch = t4;
  let t5;
  if ($[8] !== handleClose) {
    t5 = open => {
      if (!open) {
        handleClose();
      }
    };
    $[8] = handleClose;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Dialog.Overlay className="fixed inset-0 z-40 bg-black/30 desktop-lg:hidden" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = `fixed inset-0 z-50 overflow-y-auto bg-surface-base-primary text-text-primary${" desktop-lg:hidden"}${isBusinesses ? " dark" : ""}`;
  let t8;
  if ($[11] !== handleClose) {
    t8 = event => {
      if ((event.target as HTMLElement).closest("a")) {
        handleClose();
      }
    };
    $[11] = handleClose;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("navigationMenu");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <Dialog.Title className="sr-only">{t9}</Dialog.Title>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="border-b border-border-subtle"><AudienceTabs variant="mobile" /></div>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t) {
    t12 = t("search");
    $[18] = t;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Icon size="lg" name="search" className="text-text-secondary" />;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t) {
    t14 = t("search");
    $[21] = t;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14) {
    t15 = <span className="typography-body-sm text-text-disabled">{t14}</span>;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== handleSearch || $[26] !== t12 || $[27] !== t15) {
    t16 = <button type="button" onClick={handleSearch} className="flex flex-1 items-center gap-2 rounded-full border border-border-subtle px-4 py-2 text-left" aria-label={t12}>{t13}{t15}</button>;
    $[25] = handleSearch;
    $[26] = t12;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Icon name="close" size="lg" className="text-text-primary" />;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== handleClose) {
    t18 = <button type="button" onClick={handleClose} className="flex items-center justify-center" aria-label="Close menu">{t17}</button>;
    $[30] = handleClose;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t16 || $[33] !== t18) {
    t19 = <div className="flex items-center gap-2 py-4">{t16}{t18}</div>;
    $[32] = t16;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== activeMenu || $[36] !== effectiveSectionId || $[37] !== isBusinesses || $[38] !== primaryMenuItems || $[39] !== utilityItems) {
    t20 = effectiveSectionId === null || !activeMenu ? <MobileMenuLevel2 menuItems={primaryMenuItems ?? null} utilityItems={utilityItems} onSelectSection={setActiveSectionId} showPlanVisitCta={PLANNER_ENABLED && !isBusinesses} /> : <MobileMenuLevel3 menu={activeMenu} onBack={() => setActiveSectionId(null)} />;
    $[35] = activeMenu;
    $[36] = effectiveSectionId;
    $[37] = isBusinesses;
    $[38] = primaryMenuItems;
    $[39] = utilityItems;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t19 || $[42] !== t20) {
    t21 = <div className="flex h-full flex-col">{t11}<div className="flex flex-col px-4 h-full">{t19}{t20}</div></div>;
    $[41] = t19;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t10 || $[45] !== t21 || $[46] !== t7 || $[47] !== t8) {
    t22 = <Dialog.Portal>{t6}<Dialog.Content className={t7} onClick={t8}>{t10}{t21}</Dialog.Content></Dialog.Portal>;
    $[44] = t10;
    $[45] = t21;
    $[46] = t7;
    $[47] = t8;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== isMobileMenuOpen || $[50] !== t22 || $[51] !== t5) {
    t23 = <Dialog.Root open={isMobileMenuOpen} onOpenChange={t5}>{t22}</Dialog.Root>;
    $[49] = isMobileMenuOpen;
    $[50] = t22;
    $[51] = t5;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  return t23;
}